import { css } from "@emotion/react";
import React from "react";

export const VisuallyHidden = (
  props: React.ComponentPropsWithoutRef<"div">,
) => {
  return (
    <div
      css={css`
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0px;
        margin: 0px -1px -1px 0px;
        overflow: hidden;
        clip: rect(0px, 0px, 0px, 0px);
        clip-path: inset(50%);
        white-space: nowrap;
        border: 0px;
      `}
      {...props}
    />
  );
};
